import { render, staticRenderFns } from "./ServizioPeriodicoList.vue?vue&type=template&id=18dea8d6&"
import script from "./ServizioPeriodicoList.vue?vue&type=script&lang=ts&"
export * from "./ServizioPeriodicoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports